import React from 'react';
import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import { Button, ConfigProvider, Layout, Typography } from 'antd';
import { loginRequest } from './authConfig';
import { antdTheme, colors, fontSerif } from './theme';
import LinkTable from './components/LinkTable';

const { Header, Content } = Layout;
const { Title } = Typography;

function App() {
  const isAuthenticated = useIsAuthenticated();
  const { instance, accounts } = useMsal();

  const handleLogin = () => instance.loginRedirect(loginRequest);
  const handleLogout = () => instance.logoutRedirect();

  async function getToken() {
    const res = await instance.acquireTokenSilent({
      ...loginRequest,
      account: accounts[0]
    });
    return res.accessToken;
  }

  return (
    <ConfigProvider theme={antdTheme}>
      <Layout style={{ minHeight: '100vh' }}>
        <Header style={{ background: colors.midnight, display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '0 32px', height: 64 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <span style={{
              width: 14, height: 14, border: `2px solid ${colors.blue}`,
              transform: 'rotate(45deg)', flexShrink: 0, display: 'inline-block'
            }} />
            <span style={{ color: '#fff', fontSize: 12, fontWeight: 500, letterSpacing: '0.14em', textTransform: 'uppercase' }}>
              QuadReal Property Group
            </span>
            <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: 16, lineHeight: 1 }}>|</span>
            <Title level={4} style={{ color: '#fff', margin: 0, fontFamily: fontSerif, fontWeight: 600 }}>
              AI Quick Link
            </Title>
          </div>
          {isAuthenticated ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
              <span style={{ color: '#fff' }}>{accounts[0]?.username}</span>
              <Button onClick={handleLogout} style={{ color: '#fff', borderColor: '#fff', background: 'transparent' }}>Sign out</Button>
            </div>
          ) : (
            <Button onClick={handleLogin} style={{ color: '#fff', borderColor: '#fff', background: 'transparent' }}>Sign in</Button>
          )}
        </Header>
        <Content style={{ padding: 32, background: colors.neutral2 }}>
          {isAuthenticated ? (
            <LinkTable getToken={getToken} />
          ) : (
            <Title level={3} style={{ fontFamily: fontSerif, color: colors.midnight }}>Sign in to manage links.</Title>
          )}
        </Content>
      </Layout>
    </ConfigProvider>
  );
}

export default App;
